import { useState } from "react";
import { ExternalLink } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_gta-premium-clean/artifacts/gr00ff6c_Logo.jpeg";

const socialLinks = [
  {
    name: "Instagram",
    url: "https://www.instagram.com/torontopremiumcleaning",
    icon: (
      <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
      </svg>
    )
  },
  {
    name: "WhatsApp",
    url: "https://api.whatsapp.com/send?phone=16478700445",
    icon: (
      <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
    )
  },
  {
    name: "TikTok",
    url: "https://www.tiktok.com/@torontopremiumcleaning",
    icon: (
      <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
        <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
      </svg>
    )
  },
  {
    name: "YouTube",
    url: "https://www.youtube.com/@TorontoPremiumCleaning?sub_confirmation=1",
    icon: (
      <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
        <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    )
  },
  {
    name: "Threads",
    url: "https://www.threads.net/@torontopremiumcleaning",
    icon: (
      <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
        <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.907 3.59 12c.025 3.091.716 5.494 2.055 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.96-.065-1.182.408-2.256 1.33-3.022.88-.73 2.082-1.146 3.39-1.17.944-.018 1.836.14 2.66.468l-.003-.038c-.015-.96-.056-1.96-.419-2.703-.275-.563-.744-.958-1.514-1.14-.124-.03-.325-.058-.594-.083l.007 2.065c0 .404-.097.762-.284 1.048-.188.287-.47.507-.825.644a.622.622 0 01-.326.048c-.467-.053-.574-.464-.555-.788l.091-2.925c-.922.065-1.742.3-2.394.695-.793.48-1.202 1.107-1.216 1.866-.012.616.239 1.14.748 1.558.476.392 1.143.6 1.927.6.067 0 .135-.002.203-.005 1.014-.055 1.776-.434 2.329-1.16.358-.47.597-1.058.727-1.778.178-.05.356-.096.535-.134-.01-.573-.06-1.201-.183-1.87-.258-1.4-.805-2.366-1.628-2.873a4.313 4.313 0 00-.387-.207c-.197-.09-.406-.168-.625-.232-1.271-.372-2.9-.183-4.086.67-1.139.82-1.744 2.066-1.703 3.508.054 1.89 1.075 3.42 2.793 4.186 1.023.457 2.247.583 3.457.355a6.397 6.397 0 001.206-.368c.486.555 1.142.978 1.955 1.265.544.192 1.15.315 1.808.367-.756 1.116-1.882 1.93-3.332 2.405-1.094.358-2.344.492-3.67.39z"/>
      </svg>
    )
  }
];

const mainLinks = [
  {
    title: "Website",
    description: "Book your cleaning service online",
    url: "https://www.torontopremiumcleaning.ca/",
    icon: "🌐"
  },
  {
    title: "Instagram",
    description: "Follow us for cleaning tips & updates",
    url: "https://www.instagram.com/torontopremiumcleaning",
    icon: "📸"
  },
  {
    title: "TikTok",
    description: "Watch our cleaning transformations",
    url: "https://www.tiktok.com/@torontopremiumcleaning",
    icon: "🎬"
  },
  {
    title: "YouTube",
    description: "Subscribe for cleaning tutorials",
    url: "https://www.youtube.com/@TorontoPremiumCleaning?sub_confirmation=1",
    icon: "▶️"
  },
  {
    title: "Facebook",
    description: "Join our community",
    url: "https://www.facebook.com/torontopremiumcleaning",
    icon: "👥"
  },
  {
    title: "Threads",
    description: "Follow our conversations",
    url: "https://www.threads.net/@torontopremiumcleaning",
    icon: "💬"
  },
  {
    title: "Refer a Friend - Get $25",
    description: "Share the shine, earn rewards!",
    url: "https://www.torontopremiumcleaning.ca/refer",
    icon: "🎁",
    highlight: true
  }
];

export default function LinksPage() {
  return (
    <div data-testid="links-page" className="min-h-screen bg-gradient-to-b from-[#064E3B] to-[#043027]">
      <div className="max-w-lg mx-auto px-4 py-12">
        {/* Profile Section */}
        <div className="text-center mb-8">
          {/* Logo */}
          <div className="w-36 h-36 mx-auto mb-6 rounded-full overflow-hidden shadow-2xl bg-white p-1">
            <img
              src={LOGO_URL}
              alt="Toronto Premium Cleaning"
              className="w-full h-full object-cover rounded-full"
            />
          </div>
          
          {/* Bio - Using Manrope */}
          <p className="text-[#C0A062] text-sm leading-relaxed max-w-sm mx-auto font-medium" style={{ fontFamily: "'Manrope', sans-serif" }}>
            Premium cleaning services for homes, offices, Airbnb properties, and post-renovation sites across the Greater Toronto Area
          </p>
        </div>

        {/* Social Icons Row */}
        <div className="flex justify-center gap-4 mb-8">
          {socialLinks.map((social) => (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-11 h-11 rounded-full bg-white/10 hover:bg-[#C0A062] flex items-center justify-center text-white transition-all duration-300 hover:scale-110"
              title={social.name}
              data-testid={`social-${social.name.toLowerCase()}`}
            >
              {social.icon}
            </a>
          ))}
        </div>

        {/* Main Links */}
        <div className="space-y-3">
          {mainLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`block w-full p-4 rounded-xl text-center transition-all duration-300 hover:scale-[1.02] hover:shadow-lg ${
                link.highlight
                  ? "bg-[#C0A062] hover:bg-[#B08D55] text-white"
                  : "bg-white/95 hover:bg-white text-[#0C0A09]"
              }`}
              data-testid={`link-${index}`}
            >
              <div className="flex items-center justify-center gap-3">
                <span className="text-xl">{link.icon}</span>
                <div className="text-left">
                  <p className={`font-semibold ${link.highlight ? "text-white" : "text-[#0C0A09]"}`}>
                    {link.title}
                  </p>
                  <p className={`text-xs ${link.highlight ? "text-white/80" : "text-[#78716C]"}`}>
                    {link.description}
                  </p>
                </div>
                <ExternalLink className={`w-4 h-4 ml-auto ${link.highlight ? "text-white/70" : "text-[#78716C]"}`} />
              </div>
            </a>
          ))}
        </div>

        {/* Footer */}
        <div className="mt-12 text-center">
          <p className="text-white/40 text-xs">
            © {new Date().getFullYear()} Toronto Premium Cleaning
          </p>
          <p className="text-white/30 text-xs mt-1">
            Serving the Greater Toronto Area
          </p>
        </div>
      </div>
    </div>
  );
}
